import React from 'react';
import './style.scss';

import WpsPayment from '../WpsPayment';

import { paymentInfo } from '@pages/checkout/types';
import { MappedPaymentComponentsType } from '@global/types/types';

interface IProps {
  paymentMethod: string;
  selectedPaymentMethod: string;
  paymentInitData: paymentInfo;
  paymentComponentMap: MappedPaymentComponentsType;
}

const PaymentMethod: React.FC<IProps> = ({
  paymentMethod,
  selectedPaymentMethod,
  paymentInitData,
  paymentComponentMap,
}) => {
  return (
    <>
      <div className="order-summary__promotion__text-block">
        <div className="order-summary__promotion__text">
          <div className="payment-section">
            <div
              className={`wps-payment ${
                paymentMethod === selectedPaymentMethod ? 'show' : 'hidden'
              }`}
            >
              <WpsPayment
                paymentMethod={paymentMethod}
                paymentInitData={paymentInitData}
                paymentComponentMap={paymentComponentMap}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentMethod;
